import { Outlet, createFileRoute } from "@tanstack/react-router";

type QuotesSearch = {
	view?: string;
	create?: boolean;
};

export const Route = createFileRoute("/commerce/quotes")({
	validateSearch: (search: Record<string, unknown>): QuotesSearch => ({
		view: typeof search.view === "string" ? search.view : undefined,
		create: search.create === true || search.create === "true" ? true : undefined,
	}),
	component: () => <Outlet />,
});
